import React, { useState } from 'react';
import { ArrowLeft, Fingerprint, ScanFace, Trash2, RotateCcw, Calendar } from 'lucide-react';
import { StatCard } from '../components/StatCard';
import { BiometricStatusIcon } from '../components/BiometricStatusIcon';
interface EmployeeProfilePageProps {
  onBack: () => void;
}
export function EmployeeProfilePage({
  onBack
}: EmployeeProfilePageProps) {
  const [activeTab, setActiveTab] = useState<'biometrics' | 'attendance' | 'actions'>('biometrics');
  return <div className="bg-slate-900 min-h-full pb-20" data-id="element-108">
      {/* Header */}
      <div className="bg-slate-800 p-4 pb-6 rounded-b-3xl border-b border-slate-700" data-id="element-109">
        <button onClick={onBack} className="text-slate-400 mb-4 hover:text-white" data-id="element-110">
          <ArrowLeft size={24} data-id="element-111" />
        </button>

        <div className="flex items-start justify-between" data-id="element-112">
          <div className="flex items-center space-x-4" data-id="element-113">
            <div className="w-16 h-16 rounded-full bg-slate-600 flex items-center justify-center text-2xl font-bold text-white" data-id="element-114">
              S
            </div>
            <div data-id="element-115">
              <h1 className="text-xl font-bold text-white" data-id="element-116">Sarah Connor</h1>
              <p className="text-slate-400 text-sm" data-id="element-117">ID: EMP001 • Manager</p>
              <div className="flex items-center space-x-2 mt-2" data-id="element-118">
                <span className="px-2 py-0.5 bg-green-500/10 text-green-400 text-xs rounded-full border border-green-500/20" data-id="element-119">
                  Active
                </span>
                <span className="text-slate-500 text-xs" data-id="element-120">•</span>
                <span className="text-slate-400 text-xs" data-id="element-121">Joined Jan 2023</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 space-y-6" data-id="element-122">
        {/* Quick Stats */}
        <div className="grid grid-cols-2 gap-3" data-id="element-123">
          <StatCard label="This Month" value="22 Days" icon={<Calendar size={16} data-id="element-125" />} data-id="element-124" />
          <StatCard label="Completeness" value="100%" subtext="Biometrics Enrolled" data-id="element-126" />
        </div>

        {/* Tabs */}
        <div data-id="element-127">
          <div className="flex border-b border-slate-700 mb-4" data-id="element-128">
            {['biometrics', 'attendance', 'actions'].map(tab => <button key={tab} onClick={() => setActiveTab(tab as any)} className={`flex-1 pb-3 text-sm font-medium capitalize transition-colors relative ${activeTab === tab ? 'text-blue-400' : 'text-slate-400'}`} data-id="element-129">
                {tab}
                {activeTab === tab && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500 rounded-t-full" data-id="element-130" />}
              </button>)}
          </div>

          {/* Tab Content */}
          <div className="space-y-4" data-id="element-131">
            {activeTab === 'biometrics' && <div className="space-y-3" data-id="element-132">
                <div className="bg-slate-800 p-4 rounded-xl border border-slate-700 flex items-center justify-between" data-id="element-133">
                  <div className="flex items-center space-x-3" data-id="element-134">
                    <div className="p-2 bg-slate-700 rounded-lg text-slate-300" data-id="element-135">
                      <Fingerprint size={24} data-id="element-136" />
                    </div>
                    <div data-id="element-137">
                      <h3 className="text-white font-medium" data-id="element-138">Fingerprint</h3>
                      <p className="text-slate-400 text-xs" data-id="element-139">
                        Right Thumb, Right Index
                      </p>
                    </div>
                  </div>
                  <button className="px-3 py-1.5 bg-slate-700 text-white text-xs font-medium rounded-lg hover:bg-slate-600" data-id="element-140">
                    Re-enroll
                  </button>
                </div>

                <div className="bg-slate-800 p-4 rounded-xl border border-slate-700 flex items-center justify-between" data-id="element-141">
                  <div className="flex items-center space-x-3" data-id="element-142">
                    <div className="p-2 bg-slate-700 rounded-lg text-slate-300" data-id="element-143">
                      <ScanFace size={24} data-id="element-144" />
                    </div>
                    <div data-id="element-145">
                      <h3 className="text-white font-medium" data-id="element-146">Face ID</h3>
                      <p className="text-slate-400 text-xs" data-id="element-147">
                        Last updated 2 months ago
                      </p>
                    </div>
                  </div>
                  <button className="px-3 py-1.5 bg-slate-700 text-white text-xs font-medium rounded-lg hover:bg-slate-600" data-id="element-148">
                    Update
                  </button>
                </div>
              </div>}

            {activeTab === 'attendance' && <div className="text-center py-8 text-slate-500 text-sm" data-id="element-149">
                Showing last 5 records...
                {/* Placeholder for attendance list */}
              </div>}

            {activeTab === 'actions' && <div className="space-y-3" data-id="element-150">
                <button className="w-full p-4 bg-slate-800 border border-slate-700 rounded-xl flex items-center space-x-3 text-white hover:bg-slate-700 transition-colors" data-id="element-151">
                  <RotateCcw size={20} className="text-yellow-500" data-id="element-152" />
                  <span className="font-medium" data-id="element-153">Reset All Biometrics</span>
                </button>
                <button className="w-full p-4 bg-slate-800 border border-slate-700 rounded-xl flex items-center space-x-3 text-red-400 hover:bg-red-500/10 transition-colors" data-id="element-154">
                  <Trash2 size={20} data-id="element-155" />
                  <span className="font-medium" data-id="element-156">Archive Employee</span>
                </button>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}